import React from 'react'
import "./Achievement.css"
import leet50 from "../../assets/leetcode2024.png"
import leet100 from "../../assets/leetcode100.png"
import { Award, Trophy, Star } from 'lucide-react'

const Achievement = () => {
  return (
    <div className="min-h-screen bg-[#0b0f19] py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Glows */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-white/5 rounded-full blur-[120px] -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-black/5 rounded-full blur-[120px] translate-x-1/2 translate-y-1/2" />

      <div className="max-w-[1400px] mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-24">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 border border-white/20 rounded-full mb-6">
            <Trophy className="h-4 w-4 text-white" />
            <span className="text-white text-[10px] font-black tracking-widest uppercase">Honors</span>
          </div>
          <h2 className="text-5xl md:text-7xl font-black mb-6 tracking-tighter">
            <span className="text-white">Milestones & </span>
            <span className="gradient-text">
              Impact
            </span>
          </h2>
          <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto font-medium leading-relaxed">
            Certifications, awards, and the digital trophies earned through continuous <span className="text-white font-bold">engineering excellence</span>.
          </p>
        </div>

        {/* Achievements Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Achievement Card 1 */}
          <div className="group relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-white to-gray-400 rounded-[2rem] blur opacity-10 group-hover:opacity-30 transition duration-500"></div>
            <div className="relative bg-[#111928]/40 backdrop-blur-2xl rounded-[2rem] p-8 h-full border border-white/5 group-hover:border-white/30 transition-all duration-500 shadow-xl">
              <div className="h-52 mb-8 overflow-hidden rounded-2xl bg-[#0b0f19]/50 flex items-center justify-center p-6 border border-white/5">
                <img
                  src={leet50}
                  alt="50 Days LeetCode"
                  className="h-full object-contain transform group-hover:scale-110 group-hover:-rotate-3 transition-all duration-700"
                />
              </div>
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-white/10 rounded-lg text-white">
                  <Star size={18} fill="currentColor" />
                </div>
                <h3 className="text-2xl font-black text-white tracking-tight group-hover:text-white transition-colors">50-Days Streak</h3>
              </div>
              <p className="text-gray-300 text-sm font-medium leading-relaxed">Sustained analytical intensity for 50 consecutive days on the LeetCode platform.</p>
            </div>
          </div>

          {/* Achievement Card 2 */}
          <div className="group relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-gray-400 to-white rounded-[2rem] blur opacity-10 group-hover:opacity-30 transition duration-500"></div>
            <div className="relative bg-[#111928]/40 backdrop-blur-2xl rounded-[2rem] p-8 h-full border border-white/5 group-hover:border-white/30 transition-all duration-500 shadow-xl">
              <div className="h-52 mb-8 overflow-hidden rounded-2xl bg-[#0b0f19]/50 flex items-center justify-center p-6 border border-white/5">
                <img
                  src={leet100}
                  alt="100 Days LeetCode"
                  className="h-full object-contain transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-700"
                />
              </div>
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-white/10 rounded-lg text-white">
                  <Award size={18} fill="currentColor" />
                </div>
                <h3 className="text-2xl font-black text-white tracking-tight group-hover:text-white transition-colors">100-Days Honor</h3>
              </div>
              <p className="text-gray-300 text-sm font-medium leading-relaxed">Elite consistency milestone in solving complex algorithmic challenges and optimizing code.</p>
            </div>
          </div>

          {/* Achievement Card 3 */}
          <div className="group relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-gray-300 to-gray-500 rounded-[2rem] blur opacity-10 group-hover:opacity-30 transition duration-500"></div>
            <div className="relative bg-[#111928]/40 backdrop-blur-2xl rounded-[2rem] p-8 h-full border border-white/5 group-hover:border-white/30 transition-all duration-500 shadow-xl">
              <div className="h-52 mb-8 overflow-hidden rounded-2xl bg-[#0b0f19]/50 flex items-center justify-center p-6 border border-white/5">
                <Trophy size={80} className="text-white/20 group-hover:text-white transition-colors duration-500" />
              </div>
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-white/10 rounded-lg text-white">
                  <Trophy size={18} fill="currentColor" />
                </div>
                <h3 className="text-2xl font-black text-white tracking-tight group-hover:text-white transition-colors">Problem Solving Ace</h3>
              </div>
              <p className="text-gray-300 text-sm font-medium leading-relaxed">Top-tier performance across multiple competitive platforms, demonstrating agile engineering logic.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
};

export default Achievement
